export default __webpack_public_path__ + "static/media/logo-w.67a8f4e3.svg";